// ============================================================================
// RequireAuth — route guard. While the auth state resolves it shows a quiet
// full-screen loader; if unauthenticated it redirects to /login (preserving
// the attempted location so login can send the trainer back). Authenticated
// children render via <Outlet/>.
// ============================================================================
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext";
import { FullPageSpinner } from "../components/FullPageSpinner";

export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (isLoading)
    return <FullPageSpinner label={t("common.loadingStudio")} />;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
